import { createApi } from "@reduxjs/toolkit/dist/query/react";
import { oktaTokenBaseQuery, oktaTokenBaseRequest } from "@/react/services/api";

const VERSION_URL_PATH = "/v1/version";

export const metadataApi = createApi({
  baseQuery: oktaTokenBaseQuery(),
  reducerPath: "metadataApi",
  endpoints: (build) => ({
    getBEAppVersion: build.query({
      query: () => ({
        url: VERSION_URL_PATH,
        method: "GET",
      }),
    }),
  }),
});

export const { useGetBEAppVersionQuery } = metadataApi;

export const getBEAppVersion = async () => {
  try {
    const response = await oktaTokenBaseRequest(VERSION_URL_PATH);
    return response.text();
  } catch (e) {
    console.error("Fetch failure getting backend version.", e);
    return Promise.reject(new Error("Fetch failure", { cause: e }));
  }
};
